import React, { useState } from 'react';
import { message } from 'antd';
import { useNavigate } from 'react-router-dom';
import { authService } from '../../services/api';
import '../../css/Login.css';
import '../../css/ForgotPassword.css';
import { useTranslation } from 'react-i18next';

const ForgotPassword = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [emailSent, setEmailSent] = useState(false);
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const { t } = useTranslation(['auth']);

  const handleSubmit = async (e) => {
    e.preventDefault();

    setError('');

    if (!email || !email.trim()) {
      setError(t('auth:forgot.email_required'));
      return;
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      setError(t('auth:forgot.email_invalid'));
      return;
    }

    setLoading(true);
    try {
      await authService.forgotPassword(email);
      setEmailSent(true);
      message.success(t('auth:forgot.success_toast'));
    } catch (error) {
      const errorMessage = error.response?.data?.message || t('auth:forgot.fail_toast');
      setError(errorMessage);
      message.error(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  const handleBackToLogin = () => {
    navigate('/login');
  };

  const handleInputChange = (value) => {
    setEmail(value);
    if (error) {
      setError('');
    }
  };

  if (emailSent) {
    return (
      <div className="login-page">
        <div className="auth-container" style={{ maxWidth: '36rem' }}>
          <div className="auth-card" style={{ minHeight: 'auto' }}>
            <div className="auth-form-panel">
              <div className="auth-form-content">
                <div className="forgot-password-success-content">
                  <div className="forgot-password-success-icon">&#9993;</div>
                  <h2>{t('auth:forgot.sent_title')}</h2>
                  <p>{t('auth:forgot.sent_desc')}</p>
                  <p className="forgot-password-note">{t('auth:forgot.sent_note')}</p>
                  <button
                    type="button"
                    className="submit-btn"
                    onClick={handleBackToLogin}
                  >
                    {t('auth:forgot.back_login')}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="login-page">
      <div className="auth-container" style={{ maxWidth: '36rem' }}>
        <div className="auth-card" style={{ minHeight: 'auto' }}>
          <div className="auth-form-panel">
            <div className="auth-form-content">
              <form onSubmit={handleSubmit} className="auth-form">
                <button
                  type="button"
                  className="forgot-password-back-link"
                  onClick={handleBackToLogin}
                >
                  &larr; {t('auth:forgot.back_login')}
                </button>
                <h1 className="forgot-password-title">{t('auth:forgot.title')}</h1>
                <p className="forgot-password-desc">{t('auth:forgot.desc')}</p>

                <div className="input-group">
                  <input
                    type="email"
                    placeholder={t('auth:forgot.email_placeholder')}
                    value={email}
                    onChange={(e) => handleInputChange(e.target.value)}
                    className="auth-input"
                  />
                </div>

                {error && (
                  <div className="error-message">
                    {error}
                  </div>
                )}

                <button type="submit" disabled={loading} className="submit-btn">
                  {t('auth:forgot.submit')}
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword; 